module.exports = __webpack_public_path__ + "img/brand-04.f60ed605.png";